import { Money } from '@libs/money/money.interfaces';
import { Nationality } from '@/api/Cart/cart.interfaces';
import { PreCheckoutData } from '@shared/interfaces/preCheckout';
export interface CheckoutEndpoint {
    GetStaticCheckoutPageContent(): Promise<StaticCheckoutContent>;
    GetPreCheckoutData(optionLimit?: number): Promise<PreCheckoutData>;
    RedeemDiscountCode(discountCode: string): Promise<DiscountCodeResponse>;
}

export interface StaticCheckoutContent {
    IsCaptumAvailable: boolean;
    Disclaimers: Disclaimer[];
    GenderTitles: Gender;
    DiscountEnabled: boolean;
    Nationalities: Nationality[];
    CurrentNationality: string;
    PhoneNumberPrefixes: PhoneNumberPrefix;
    SpecialNeedsOptions: SpecialNeedsOption[];
    AgeRangeDefinitions: AgeRangeDefinitionsResult | null;
}

export interface Gender {
    [key: number]: string;
}
export enum GenderKey {
    'Unknown' = 0,
    'Male' = 1,
    'Female' = 2,
}

interface PhoneNumberPrefix {
    prefixes: string[];
    selected: string;
}

export interface Disclaimer {
    Id: string;
    Label: string;
    LinkText: string | null;
    LinkUrl: string | null;
    IsCheckbox: boolean;
}

export interface SortedDisclaimers {
    DisclaimersWithCheckbox: Disclaimer[] | null;
    DisclaimersWithText: Disclaimer[] | null;
}

export interface SpecialNeedsOption {
    Name: string;
    Value: number;
}

export interface DiscountCodeResponse {
    Discount: Money | null;
    ErrorMessage: string;
}

export interface AgeRangeDefinitionsResult {
    Ferry: AgeRanges;
    Flight: AgeRanges;
}

export interface AgeRangeDefinitions extends AgeRangeDefinitionsExtra {
    Ferry: AgeRanges;
    Flight: AgeRanges;
}

interface AgeRangeDefinitionsExtra {
    Hotel: AgeRanges;
}

export interface AgeRange {
    Min: number;
    Max: number;
    Type: PassengerType;
}

export interface AgeRanges {
    Adult: AgeRange;
    Child: AgeRange;
    Infant: AgeRange;
}
export enum PassengerType {
    Unknown = 'Unknown',
    Adult = 'Adult',
    Child = 'Child',
    Infant = 'Infant',
}
